var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg169Empty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 1024.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 5120 l0 -2750 4360 0 4360 0 0 2750 0 2750 -4360 0 -4360 0 0 -2750z m8300 0 l0 -2330 -3940 0 -3940 0 0 2330 0 2330 3940 0 3940 0 0 -2330z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg169Empty);
export default __webpack_public_path__ + "static/media/16_9_empty.e4b3acd5a10f01f7c435b4f529c61079.svg";
export { ForwardRef as ReactComponent };